export const KA = {
    translations: {
        notifications: 'ಅಧಿಸೂಚನೆಗಳು',
        markAllAsRead: 'ಎಲ್ಲವನ್ನು ಓದಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ',
        poweredBy: 'ಮೂಲಕ ನಡೆಸಲ್ಪಡುತ್ತಿದೆ',
        settings: 'ಸಂಯೋಜನೆಗಳು',
        noNewNotification: 'აქ ახალი სანახავი ჯერ არაფერია',
    },
    lang: 'ka',
};
//# sourceMappingURL=ka.js.map